import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import noImagen from "images/no-image.jpg";

export const ImageWithFallback = ({ src, alt, className, style }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!src) {
    return <img src={noImagen} alt={alt} className={className} style={style} />;
  }

  return (
    <>
      <img
        src={src}
        alt={alt}
        className={className}
        style={style}
        onClick={() => setIsOpen(true)}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImagen;
        }}
      />
      <Lightbox
        open={isOpen}
        close={() => setIsOpen(false)}
        slides={[{ src, crossOrigin: "anonymous" }]}
        styles={{ image: { background: "white" } }}
        render={{
          slide: ({ slide }) => (
            <div
              style={{
                display: "inline-block",
                backgroundColor: "white",
              }}
            >
              <img
                src={slide.src}
                style={{
                  display: "block",
                  maxWidth: "80vw",
                  maxHeight: "80vh",
                }}
              />
            </div>
          ),
        }}
      />
    </>
  );
};
